import { action, makeObservable } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { OrderPIIService } from 'common/data';
import _ from 'lodash';

class OrderPIIStore extends BaseStore {
	constructor(rootStore) {
		super(new OrderPIIService(rootStore.app.baasic.apiClient));
		makeObservable(this);
	}

	@action
	checkIfOrderAddressPIIExistsAsync = async (id, isFulfillmentOrder, isView, orderId) => {
		const response = await this.service.checkIfOrderAddressPIIExistsAsync(id, isFulfillmentOrder, isView, orderId);
		this.response = response.data;
		return response.data;
	};
}

export default OrderPIIStore;
